import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetVideoStudiosShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getVideoStudiosShortInfo } from 'backend/videos';
import { TEditVideoSelectedItem } from '../../../../../../../../editVideoState/editVideoContext';
import { useTranslation } from 'react-i18next';

interface IStudioSelect {
	setFetchedStudios: (value: IItemForGetShortInfo[]) => void;
	setIDStudio: (value: TEditVideoSelectedItem) => void;
	refetchStudios: (value: boolean) => void;
	needRefetchStudios: boolean;
}

const StudioSelect: React.FC<IStudioSelect> = ({
	setFetchedStudios,
	setIDStudio,
	refetchStudios,
	needRefetchStudios,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetVideoStudiosShort, void>(
		getVideoStudiosShortInfo,
	);
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectStudio') }], [t]);

	useEffect(() => {
		if (response) {
			setFetchedStudios(response.data.videoStudios);
		}
	}, [response]);

	useEffect(() => {
		if (needRefetchStudios) {
			refetch();
			refetchStudios(false);
		}
	}, [needRefetchStudios]);

	return (
		<FormSelect
			testId="StudioSelect"
			name="IDSelectedStudio"
			label="studioLabel"
			options={response?.data.videoStudios}
			fetchError={responseError}
			loading={loading}
			disabled={loading}
			onRefetch={refetch}
			onChange={setIDStudio}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(StudioSelect);
